<template>
  <svg :width="width" :height="height" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect :width="width" :height="height" rx="20" fill="#EB5757"/>
    <path d="M21.4165 24.7896C21.0956 24.7896 20.8127 25.0225 20.7201 25.3625L19.7255 29.0164C19.6521 29.2867 19.456 29.4947 19.2089 29.5644L14.2166 30.9747C13.8604 31.0754 13.493 30.8678 13.3597 30.4886C13.0182 29.5176 12.3888 27.7416 12.0886 26.9806C12.0254 26.8204 11.9908 26.6479 12.0021 26.4737C12.2802 22.1578 18.6399 19.9999 24.9996 20C31.36 19.9997 37.7198 22.1577 37.9979 26.4736C38.0091 26.648 37.9745 26.8206 37.9114 26.9805C37.6114 27.7414 36.9819 29.5175 36.6404 30.4885C36.5071 30.8677 36.1397 31.0753 35.7835 30.9746L30.7912 29.5641C30.5443 29.4943 30.3482 29.2863 30.2746 29.0162L29.2803 25.3626C29.1877 25.0226 28.9048 24.7896 28.5838 24.7896L21.4165 24.7896Z" fill="white"/>
  </svg>
</template>

<script>
import {colors} from "../../constants";

export default {
  props: {
    width: { type: [Number, String], default: 20 },
    height: { type: [Number, String], default: 16 },
    color: { type: String, default: colors.callIcon }
  },
  name: "IconCallStop"
}
</script>
